import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	'components': {
		'app': {
			'children': {
				'example': {},
				'wrapper': {},
			},
		},
	},
	'theme': {
		'base': {
			'application': {
				'font': {
					'family': 'Heebo, Arial',
				},
			},
			'button': {
				'background': {
					'color': '#ffffff',
				},
				'border': {
					'_value': 'none',
				},
				'color': '#4a4a4a',
				'cursor': 'pointer',
				'font': {
					'family': 'Heebo, Arial',
					'size': '14px',
					'weight': '400',
				},
				'lineHeight': '24px',
				'outline': {
					'_value': 'none',
				},
				'overrides': [
					{
						'selector': '[data-selector="base-icon-wrapper"]',
						'style': {
							'breakpoints': [
								{
									'max': '992px',
									'media': [
										'screen',
									],
									'style': {
										'padding': {
											'right': '4px',
										},
									},
								},
							],
							'float': 'right',
							'padding': {
								'right': '4px',
							},
						},
					},
				],
				'padding': {
					'left': '0px',
					'right': '0px',
				},
				'text': {
					'align': 'left',
				},
				'width': '100%',
			},
			'icon': {
				'children': {
					'wrapper': {
						'height': 'px',
						'overrides': [
							{
								'selector': '[data-selector="base-icon"]',
								'style': {
									'height': '19px',
									'padding': {
										'right': '0px',
									},
									'verticalAlign': 'middle',
									'width': '18px',
								},
							},
						],
					},
				},
				'padding': {
					'right': 'px',
				},
			},
		},
		'file': {
			'documentDownload': {
				'color': '#4a4a4a',
			},
		},
	},
};